// Created by 任泽阳 on 18/12/17. // 登录/注册/重置密码 手机/邮箱切换
<template>
  <ul
    class='into-tab gray-10-bd'
    :class='`${disabled ? "userNone" : ""} ${className}`'
  >
    <li
      v-for='(item, index) in list'
      :key='index'
      @click='setNowKey(item.key)'
      class="gray-cl"
      :class='nowKey === item.key ? "main-cl" : ""'
    >
    <!--  :style='evenStyle' -->
      {{ item.name }}
      <span v-if="nowKey === item.key" class='line-bar blue-bg'></span>
    </li>
    <!-- <span :style='barStyle' class='a-12-bg'></span> -->
  </ul>
</template>
<script>
export default {
  name: 'c-intoTab',
  props: {
    className: { default: '', type: String }, // 根节点class
    list: { default: [] }, // [{name: xx, key: xx}]
    nowKey: { default: '', type: String }, // 当前值
    disabled: { default: false, type: Boolean }, // 是否可点击
  },
  computed: {
    // 下划线样式
    barStyle() {
      const area = 100 / this.list.length; // 每份占位宽度
      let ind = 0;
      this.list.forEach((item, i) => {
        if (item.key === this.nowKey) {
          ind = i;
        }
      });
      return {
        width: `${area}%`,
        left: `${ind * area}%`,
      };
    },
    // 每一项样式
    evenStyle() {
      const area = 100 / this.list.length; // 每份占位宽度
      return { width: `${area}%` };
    },
  },
  methods: {
    setNowKey(item) {
      if (this.disabled) {
        return;
      }
      this.$emit('onchenges', item);
    },
  },
};
</script>

<style lang='stylus' scoped>
.userNone {
  li {cursor: no-drop!important}
}
.into-tab {
  width: 380px;
  height: 42px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  // position: relative;
  // span {
  //   position: absolute;
  //   height: 2px;
  //   width: 50%;
  //   bottom: -2px;
  //   transition: all 0.3s!important;
  //   left: 0;
  // }
  li {
    float: left;
    // width: 50%;
    font-size: 18px;
    line-height: 26px;
    padding-bottom: 16px;
    box-sizing: border-box;
    // line-height: 40px;
    text-align: center;
    cursor: pointer;
    user-select: none
    position: relative;
    display: inline-block;
    margin-right: 40px;
  }
  .line-bar {
    width: 24px;
    height: 4px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
  }
}
</style>
